import { render, staticRenderFns } from "./dclupload.vue?vue&type=template&id=b28a5556&scoped=true"
import script from "./dclupload.vue?vue&type=script&lang=js"
export * from "./dclupload.vue?vue&type=script&lang=js"
import style0 from "./dclupload.vue?vue&type=style&index=0&id=b28a5556&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b28a5556",
  null
  
)

export default component.exports